export default class Comments {
  constructor() {
    this.comments = document.querySelector('.comments');
  }

  _showCommentAnswer(target) {
    const currentButton = target.closest('.comment__answers');
    currentButton.classList.toggle('comment__answers--visible');
    currentButton.parentElement.parentElement.nextElementSibling
      && currentButton.parentElement.parentElement.nextElementSibling.classList.toggle('comment--answer-visible');
  }

  init() {
    if (this.comments) {
      this.comments.addEventListener('click', e => {
        e.target.closest('.comment__answers')
          ? this._showCommentAnswer(e.target)
          : e.stopPropagation();
      });
    }
  }
}